/**
 * @module List Banner
 * @description
 */
import PropTypes from "prop-types";
import styles from "./BannerList.module.css";

const defaultItems = [
  {
    copy: "Worry-free surfing and streaming",
    icon: "checkmark1",
  },
  {
    copy: "No data caps or overage charges",
    icon: "checkmark1",
  },
];

/**
 * @function Component
 * @description
 */
const Component = ({ ...props }) => {
  const { heading, items = defaultItems, theme = null } = props;

  return (
    <section
      className={`component ${styles.component} ${theme && `u-theme-${theme}`}`}
    >
      <div className="l-container">
        <div className={styles.component__body}>
          {heading && (
            <p className={`h5 ${styles.component__heading}`}>{heading}</p>
          )}

          <ul className={styles.component__list}>
            {items.map((item, index) => (
              <li key={index} className={styles.component__listItem}>
                {item.icon && (
                  <span
                    className={`icon icon-${item.icon} ${styles.component__icon} `}
                  />
                )}
                <span className={styles.component__listCopy}>{item.copy}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

Component.propTypes = {
  heading: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      copy: PropTypes.node,
    }),
  ),
  theme: PropTypes.string,
};

export default Component;
